// 51黑料 首页静态展示数据（仅演示用，不接接口）

export interface HotItem {
  rank: string;
  tag: string;
  title: string;
  summary: string;
  heat: string;
  time: string;
  trend: 'up' | 'down' | 'new';
}

export interface CollectionItem {
  index: string;
  tag: string;
  title: string;
  desc: string;
  count: number;
}

export interface ThreadItem {
  name: string;
  role: string;
  time: string;
  text: string;
  tag: string;
  replies: number;
  likes: number;
}

export interface BriefItem {
  badge: string;
  title: string;
  summary: string;
  tag: string;
  time: string;
  reads: string;
  img: string;
}

export interface RoundupItem {
  category: string;
  title: string;
  excerpt: string;
  reads: string;
  date: string;
  img: string;
}

export const navLinks = [
  { label: '今日热榜', href: '#hot' },
  { label: '话题合集', href: '#collections' },
  { label: '热议区', href: '#community' },
  { label: '精选盘点', href: '#roundups' },
  { label: '快讯流', href: '#briefs' },
  { label: '往期汇总', href: '#archive' },
];

export const brandStats = [
  { value: '12.8万', label: '今日讨论' },
  { value: '346', label: '上榜话题' },
  { value: '128', label: '精选合集' },
];

export const heroMinis = [
  { tag: '职场', title: '“弹性工时”聊了半天，落地却只改了个名', heat: '热议 6.2w' },
  { tag: '直播', title: '连续三场破纪录后，主播人设开始“塌房”', heat: '热议 5.9w' },
  { tag: '品牌', title: '联名款刚官宣，二手价已先崩了一轮', heat: '新进 4.8w' },
  { tag: '饭圈', title: '站姐停工声明刷屏，背后账目成焦点', heat: '讨论 4.1w' },
];

export const todayHot: HotItem[] = [
  { rank: '1', tag: '职场', title: '“弹性工时”聊了半天，落地却只改了个名', summary: '说好的自由排班，结果晨会还是八点雷打不动，底下的吐槽贴两小时盖到三千楼。', heat: '6.2w', time: '2分钟前', trend: 'up' },
  { rank: '2', tag: '直播', title: '连续三场破纪录后，主播人设开始“塌房”', summary: '从前喊家人们，最近被扒出发货地跟直播口播对不上，老粉评论区当场开撕。', heat: '5.9w', time: '11分钟前', trend: 'up' },
  { rank: '3', tag: '品牌', title: '联名款刚官宣，二手价已先崩了一轮', summary: '黄牛手里的货还没捂热，二级市场报价一天三变，不少人在问要不要割肉。', heat: '5.1w', time: '26分钟前', trend: 'new' },
  { rank: '4', tag: '平台', title: '改版后老用户集体“找不回车票”，客服被打爆', summary: '一刀切的入口重构，把用了三年的大多数人晾在原地，情绪贴持续刷屏。', heat: '4.6w', time: '40分钟前', trend: 'down' },
  { rank: '5', tag: '饭圈', title: '站姐停工声明刷屏，背后账目成焦点', summary: '应援明细迟迟没晒，粉丝开始自发对账，几个大粉号连夜关评论。', heat: '4.1w', time: '1小时前', trend: 'new' },
  { rank: '6', tag: '综艺', title: '赛制临时加场，选手赛后采访话里有话', summary: '一份“补充赛制”的通知把晋级名额又划了一遍，围观群众直呼好戏开场。', heat: '3.7w', time: '1小时前', trend: 'up' },
  { rank: '7', tag: '数码', title: '发布会号称“全新架构”，拆解却见旧核换新皮', summary: '供应链爆料对上官方话术，两版口径来回拉扯，评论区求实锤。', heat: '3.2w', time: '2小时前', trend: 'down' },
  { rank: '8', tag: '餐饮', title: '网红店排队两小时，后厨却被拍到“一次出十份”', summary: '现点现做的招牌成了批量半成品，现场视频热度持续走高。', heat: '2.8w', time: '2小时前', trend: 'new' },
  { rank: '9', tag: '游戏', title: '开服福利缩水，“退坑帖”一天涨了几千条', summary: '运营背刺老玩家的梗图满天飞，客服临时补了个“补偿方案”灭火。', heat: '2.4w', time: '3小时前', trend: 'down' },
  { rank: '10', tag: '影视', title: '片方换角传闻发酵，官微只回了个“周末见”', summary: '一份疑似通告单流传出来，主演名单看着眼生，粉丝与路人吵成一团。', heat: '2.1w', time: '3小时前', trend: 'up' },
];

export const collections: CollectionItem[] = [
  { index: '01', tag: '职场', title: '“饼话连篇”工作聊天记录合集', desc: '从画饼话术到背刺名场面，把职场黑话一次性盘点清楚。', count: 42 },
  { index: '02', tag: '直播', title: '头部主播“翻车”时间线汇总', desc: '按时间排序逐条复盘，谁在说一套做一套一目了然。', count: 37 },
  { index: '03', tag: '品牌', title: '联名与二手价崩盘记录', desc: '热度吹上天、价格跌穿地，收藏这份反向操作档案。', count: 28 },
  { index: '04', tag: '饭圈', title: '应援账目争议梳理', desc: '明细、对账、声明全链路收录，钱花到哪了有人替你查。', count: 53 },
  { index: '05', tag: '综艺', title: '赛制魔改全集盘点', desc: '临时改规则是节目组的常规操作还是惯用套路，看完全集再下结论。', count: 19 },
  { index: '06', tag: '数码', title: '发布会话术“拆台”实录', desc: '大词配小料，对比往代参数逐条拆，帮你戳破那层包装。', count: 31 },
];

export const threads: ThreadItem[] = [
  { name: '一只摆烂的鱼', role: '吃瓜老用户', time: '8分钟前', text: '那个联名款我蹲了俩月，结果还没到就崩价，心都凉了。有没有人扒到是库存还是噱头？', tag: '#品牌', replies: 128, likes: 940 },
  { name: '夜班食堂常客', role: '资深爆料', time: '21分钟前', text: '“弹性工时”那条我就在现场，晨会照开、考勤照打，就是改了个叫法。坐等汇总贴补全后续。', tag: '#职场', replies: 86, likes: 612 },
  { name: '瓜田里的猹', role: '路转黑', time: '36分钟前', text: '主播塌房这事，建议先看应援对账再吃瓜，别被带节奏。明细都没晒，说啥都是演。', tag: '#饭圈', replies: 203, likes: 1501 },
  { name: '半糖去冰', role: '理性围观', time: '1小时前', text: '赛制加场挺常见的，关键看加完有没有真的挤掉别人。等官方的晋级名单出了再骂也不迟。', tag: '#综艺', replies: 54, likes: 388 },
];

export const briefs: BriefItem[] = [
  { badge: '职场', title: '画饼届天花板：把降薪说成“共创机会”', summary: '内部信全文流出，逐句拆解这套话术的构成。', tag: '合集', time: '今日 09:12', reads: '3.1w', img: 'https://readdy.ai/api/search-image?query=dark%20editorial%20moody%20collage%20with%20torn%20business%20documents%20paper%20layers%20in%20charcoal%20and%20deep%20crimson%2C%20dramatic%20side%20lighting%2C%20textured%20newsprint%20background%2C%20high%20contrast%2C%20no%20text&width=640&height=640&seq=brief01&orientation=squarish' },
  { badge: '直播', title: '“家人们”变“家外人”，一场连麦彻底翻车', summary: '连麦对质全程切片，谁在转移话题看得很清楚。', tag: '新料', time: '今日 08:40', reads: '2.7w', img: 'https://readdy.ai/api/search-image?query=moody%20dark%20studio%20still%20life%20with%20torn%20poster%20and%20film%20strips%2C%20deep%20amber%20and%20charcoal%20tones%2C%20hard%20directional%20shadow%2C%20editorial%20newsprint%20grain%2C%20cinematic%2C%20no%20text&width=640&height=640&seq=brief02&orientation=squarish' },
  { badge: '品牌', title: '限时秒杀翻车，价格比日常还贵三成', summary: '后台截图+支付记录对齐，限时到底限了什么？', tag: '汇总', time: '昨日 23:05', reads: '2.2w', img: 'https://readdy.ai/api/search-image?query=dark%20minimal%20editorial%20still%20with%20layered%20ticket%20receipts%20and%20price%20tags%2C%20warm%20rust%20and%20charcoal%20palette%2C%20soft%20amber%20glow%2C%20textured%20paper%2C%20high%20contrast%20cinematic%20mood%2C%20no%20text&width=640&height=640&seq=brief03&orientation=squarish' },
  { badge: '饭圈', title: '应援明细拖更两个月，对账帖汇总已开', summary: '海量金额对不上号，几个时间点前后矛盾。', tag: '盘点', time: '昨日 21:18', reads: '1.9w', img: 'https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20scattered%20paper%20receipts%20and%20stamps%20on%20dark%20surface%2C%20crimson%20and%20ink%20tones%2C%20moody%20top%20lighting%2C%20newsprint%20texture%2C%20high%20contrast%2C%20no%20text&width=640&height=640&seq=brief04&orientation=squarish' },
  { badge: '综艺', title: '加赛通知凌晨两点发布，网友列了三点质疑', summary: '时间点、名额数、投票口径，逐条被拿出来对线。', tag: '新料', time: '昨日 18:55', reads: '1.6w', img: 'https://readdy.ai/api/search-image?query=dark%20theatre%20curtain%20and%20spotlight%20abstract%20collage%2C%20deep%20red%20and%20black%20palette%2C%20textured%20grain%2C%20editorial%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20no%20text&width=640&height=640&seq=brief05&orientation=squarish' },
  { badge: '数码', title: '“全新架构”实锤翻车，老用户怒斥收智商税', summary: '拆解报告与官方参数对不上，评论区一边倒。', tag: '合集', time: '昨日 16:32', reads: '1.4w', img: 'https://readdy.ai/api/search-image?query=moody%20macro%20of%20circuit%20board%20under%20hard%20light%2C%20dark%20charcoal%20with%20amber%20heat%20accents%2C%20editorial%20technical%20still%2C%20textured%20background%2C%20high%20contrast%20cinematic%20mood%2C%20no%20text&width=640&height=640&seq=brief06&orientation=squarish' },
];

export const roundups: RoundupItem[] = [
  { category: '本周 · 热榜盘点', title: '联名经济崩盘前夜：从“抢到就是赚”到“割肉没人接”', excerpt: '一条二手价曲线，串起黄牛、平台与普通买家各自的算盘。我们把一周的关键节点按热度排序，还原这条高开低走的完整链路。', reads: '8.6w', date: '2026.09.05', img: 'https://readdy.ai/api/search-image?query=wide%20editorial%20dark%20collage%20of%20falling%20price%20charts%20and%20torn%20branding%20paper%2C%20charcoal%20with%20deep%20crimson%20and%20amber%20accents%2C%20moody%20directional%20light%2C%20newsprint%20texture%2C%20cinematic%20high%20contrast%2C%20no%20text&width=1200&height=800&seq=roundup01&orientation=landscape' },
  { category: '深度 · 职场观察', title: '当“共创”变成话术：一份内部信的逐句拆解', excerpt: '把饼画圆不难，难的是三句话之内不穿帮。我们对照聊天记录与公开口径，整理了这套沟通话术的构成与破绽。', reads: '5.4w', date: '2026.09.04', img: 'https://readdy.ai/api/search-image?query=editorial%20dark%20still%20life%20of%20folded%20office%20documents%20and%20sticky%20notes%20with%20harsh%20shadow%2C%20deep%20charcoal%20and%20warm%20terracotta%20tones%2C%20textured%20newsprint%2C%20cinematic%20mood%2C%20no%20text&width=1200&height=800&seq=roundup02&orientation=landscape' },
  { category: '专题 · 饭圈账本', title: '应援明细迟迟不晒，粉丝开始了“全民对账”', excerpt: '从捐款时间线到物料报价，热心网友自发整理出一份对账帖，越对越有戏。本篇按热度汇总各方说法。', reads: '9.1w', date: '2026.09.03', img: 'https://readdy.ai/api/search-image?query=wide%20moody%20editorial%20of%20scattered%20ledger%20papers%20and%20receipts%20under%20single%20desk%20lamp%2C%20dark%20background%20with%20crimson%20and%20ink%20tones%2C%20textured%20grain%2C%20cinematic%20high%20contrast%2C%20no%20text&width=1200&height=800&seq=roundup03&orientation=landscape' },
];

export const hotTags = [
  '职场画饼', '主播塌房', '联名崩价', '应援对账', '赛制加场', '改版回退',
  '库存造假', '内部信', '排队注水', '架构翻车', '二手价', '半成品餐',
];

export const archiveMonths = [
  { period: '2026.08', topic: '暑期档话题总盘点', count: 76 },
  { period: '2026.07', topic: '电商大促“翻车”专题', count: 63 },
  { period: '2026.06', topic: '毕业季职场避坑合集', count: 58 },
  { period: '2026.05', topic: '五一档期营销话术观察', count: 49 },
];